<template>
  <h2>{{moduleData.title}}</h2>
  <form-general
      form-title="Nazev formulare"
      :form-obj="moduleData.form"
      :return-data="returnData"
      original-path="TODO odstranit original-path"
      :form-prefill="formPrefill"
  >
  </form-general>


</template>

<script>
import FormGeneral from "@/components/general/form/FormGeneral";
import ListGeneral from "@/components/general/list/ListGeneral";
export default {
  name: "FormModule",
  components: {
    ListGeneral,
    FormGeneral,
  },
  emits: [
    "update:reloadSignal"
  ],
  props: {
    ident: {
      type: [String],
      required: false,
      default: null,
    },
    moduleData: {
      type: [Object],
      required: false,
      default: null,
    },
    returnData: {
      type: [Object, String, Number],
      required: false,
      default: null,
    },
    route: {
      type: [Object],
      required: false,
      default: null,
    },

    /*
    "ident": String,
    "moduleData": Object,
    "returnData": [Object, String, Number],
    "route": Object,
    */
    reloadSignal: {
      type: [String],
      required: false,
      default: null,
    },
    formPrefill: {
      type: [Object],
      required: false,
      default: null,
    },
    config: {
      type: [Object],
      required: false,
      default: null,
    },

    /*
        "reloadSignal": String,

        "formPrefill": [Object],
        "config": [Object],
      */

  },
  data() {
    return {
      reloadSignalBox: null,
      reloadSignalList: null
    }
  },
  methods: {
      reloadParent(val) {
        this.$emit("update:reloadSignal", val);
      }
  },
  watch: {
    reloadSignalBox: {
      handler(val) {
        this.reloadParent(val);
      },
      immediate: true
    },
    reloadSignalList: {
      handler(val) {
        this.reloadParent(val);
      },
      immediate: true
    },
  },
  created() {

  },
  mounted() {
   // console.log("dev DashboardModule mounted x")
  }
};
</script>